module.exports = __webpack_public_path__ + "img/error.4395f4e0.png";